( function($) {

  /**
   * Stick local nav to top of window 
   * after scrolling passed the header
   */
  function applyFixedClass() {
    document.getElementById( 'navbar_bottom_of_header' ).classList.add( 'fixed-top' );
    document.getElementById( 'navbar_top_of_header' ).classList.add( 'fixed-top' );
            
    // add padding top to show content behind navbar
    navbar_height = document.querySelector( '.crockadoodle-local-nav-home' ).offsetHeight;
    document.body.style.paddingTop = navbar_height + 'px';
  }

  function removeFixedClass() {
    document.getElementById( 'navbar_bottom_of_header' ).classList.remove( 'fixed-top' );
    document.getElementById( 'navbar_top_of_header' ).classList.remove( 'fixed-top' );
            
    // remove padding top from body
    document.body.style.paddingTop = '0';
  }


  /**
   * Check window width, run function to 
   * apply or remove class on scroll 
   */
  function fixedFunction() {
    if ($(window).width() < 576 ) {
      window.addEventListener( 'scroll', function() {
        if( $(window).scrollTop() > 1 ) {
          applyFixedClass();
        }

        else {
          removeFixedClass();
        }
      } );
    }
    
    else if ($(window).width() >= 576 ) {
      window.addEventListener( 'scroll', function() {
        if( $(window).scrollTop() > 150 ) {
          applyFixedClass();
        }

        else {
          removeFixedClass();
        }
      } );
    }
  }


  /**
   * Check if IDs exist, run function on init, 
   * run function again on window resizing
   */
  if( $( '#navbar_bottom_of_header' ).length && $( '#navbar_top_of_header' ).length ) {
    fixedFunction();
    
    $( window ).on( 'resize', function() {
      fixedFunction();
    } ); 
  }



  /**
   * This snippet apparently prevents the browser from jumping to the
   * iframe Facebook feed should there be a Facebook related issue
   */
  window.onload = function() {
    $( "#cadfbfeed" ).show();
  };



  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }

    return false;
  };



  // Scroll to sort by dropdown after selecting option
  if( getUrlParameter( 'orderby' ) && $( ".woocommerce-ordering" ).length ) {
    $( [ document.documentElement, document.body ] ).animate( {
      scrollTop: ( $( ".woocommerce-ordering" ).offset().top - 150 )
    }, 1000 );
  }
  

})(jQuery); // Fully reference jQuery after this point.
